import PropTypes from 'prop-types';
import React from 'react';

const CardList = ({
  renderHeading,
  renderCard,
  children,
  renderShowMoreButton,
  banner,
  items,
  hasNextPage,
  editFollowedBrands,
}) => {
  const sectionTitle = renderHeading();
  const total = items.length;
  const cards = items.reduce((elements, item, index) => {
    if (!item) {
      return elements;
    }
    const brandId = item.id;
    const element = renderCard({
      brandId,
      index,
      editFollowedBrands,
      total,
      ...item,
    });

    if (banner && index === 2) {
      return [...elements, element, banner];
    }

    return [...elements, element];
  }, []);

  if (banner) {
    cards.pop();
  }

  if (cards.length === 0) {
    return null;
  }

  const allItemsButton = hasNextPage && renderShowMoreButton();

  return (
    <>
      {children}
      {sectionTitle}
      {cards}
      {allItemsButton}
    </>
  );
};

CardList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  hasNextPage: PropTypes.bool,
  renderCard: PropTypes.func.isRequired,
  children: PropTypes.node,
  renderHeading: PropTypes.func,
  renderShowMoreButton: PropTypes.func,
  editFollowedBrands: PropTypes.bool,
  banner: PropTypes.node,
};

CardList.defaultProps = {
  children: null,
  items: [],
  hasNextPage: false,
  renderHeading: () => null,
  renderShowMoreButton: () => null,
  banner: null,
  editFollowedBrands: false,
};

export default CardList;
